export interface DevicePropSchema {
  baseURL: string | '';
}
export class DevicePropConfig {
  private static instance: DevicePropConfig;

  config: DevicePropSchema = {
    baseURL: '',
  };

  private constructor(p_config: DevicePropSchema) {
    this.config = p_config;
  }
  getConfig = () => {
    return this.config;
  };

  getBaseUrl = () => {
    return this.config?.baseURL ?? '';
  };

  public static getInstance = (): DevicePropConfig => {
    return DevicePropConfig.instance;
  };
  public static create = (p_config: DevicePropSchema): void => {
    DevicePropConfig.instance = new DevicePropConfig(p_config);
  };
}
